// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetBusinessUnitByUserIdRequestModel from '../../model/get-business-unit-by-user-id-request-model';
import GetBusinessUnitByUserIdRequestDTO from '../dto/get-business-unit-by-user-id-request-dto';
import dtoSchema from '../schemas/get-business-unit-by-user-id-request-schema';

export default abstract class GetBusinessUnitByUserIdRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetBusinessUnitByUserIdRequestDTO>) {
    super();
    if (data) {
      this.userId = data.userId;
    }
  }
  /**
  * @type {int64}
  */
  userId?: number;

  static toModel(dto: DeepPartial<GetBusinessUnitByUserIdRequestDTO>): GetBusinessUnitByUserIdRequestModel;
  static toModel(dto: DeepPartial<GetBusinessUnitByUserIdRequestDTO> | undefined | null): GetBusinessUnitByUserIdRequestModel | undefined;
  static toModel(dto: DeepPartial<GetBusinessUnitByUserIdRequestDTO> | undefined | null): GetBusinessUnitByUserIdRequestModel | undefined {
    return dto ? new GetBusinessUnitByUserIdRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetBusinessUnitByUserIdRequestModel> | GetBusinessUnitByUserIdRequestModel): GetBusinessUnitByUserIdRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      userId: unwrapped.userId,
    } as GetBusinessUnitByUserIdRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetBusinessUnitByUserIdRequestModel, can not map to GetBusinessUnitByUserIdRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
